import { render } from "./MyAboutMe.vue?vue&type=template&id=c4a166e4&scoped=true"
import script from "./MyAboutMe.vue?vue&type=script&lang=js"
export * from "./MyAboutMe.vue?vue&type=script&lang=js"

import "./MyAboutMe.vue?vue&type=style&index=0&id=c4a166e4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4a166e4"]])

export default __exports__